import React, { useState } from "react";

import Plus from "../../images/plus.svg";
import Minus from "../../images/minusIcon.svg";

function MobileSubCategories({ item }) {
  const [openSubCat, setOpenSubCat] = useState(false);

  const openSubCategory = () => {
    setOpenSubCat(!openSubCat);
  };

  return (
    <>
      <div className="responsive_food_wrapper">
        <div className="responsive_food_item">
          <div className="box_1">
            <img
              src={item.thumbnails}
              alt="card-img"
              style={{
                width: "50px",
                height: "45px",
                borderRadius: 5,
                objectFit: "cover",
              }}
            />
            <span>{item.title}</span>
          </div>
          {openSubCat ? (
            <img
              onClick={openSubCategory}
              src={Minus}
              alt="plus icon"
              style={{
                width: 16,
                height: 16,
                cursor: "pointer",
              }}
            />
          ) : (
            <img
              onClick={openSubCategory}
              src={Plus}
              alt="plus icon"
              style={{
                width: 16,
                height: 16,
                cursor: "pointer",
              }}
            />
          )}
        </div>
        {openSubCat && (
          <div className="responsive_subCat">
            <hr className="responsive_divider" />
            <div style={{ textAlign: "center", marginTop: "1.5rem" }}>
              <span className="subCat_heading">
                This week's lunch {item.title.toLowerCase()} menu
              </span>
            </div>
            {item.menu.map((menu) => {
              return (
                <div
                  className="sub_card"
                  style={{
                    marginBottom: ".9rem",
                    marginTop: "1rem",
                    borderRadius: 5,
                    width: "100%",
                  }}
                >
                  <img
                    src={menu.primaryImg}
                    alt="cardImg"
                    style={{ width: "100%", borderRadius: 5, height: "174px" }}
                  />
                  <div className="card_body_container">
                    <h3 style={{ marginTop: ".5rem" }}>{menu.title}</h3>
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span style={{ color: "#8895A7", fontWeight: "bold" }}>
                        {menu.subtitle}
                      </span>
                      <div className="ratings_box">&#9733; {menu.rating}</div>
                    </div>
                    <h3 style={{ marginBottom: "1.2rem" }}>{menu.day}</h3>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </>
  );
}

export default MobileSubCategories;
